import PixelDebugger from '@analytics/components/pixels/PixelDebugger';
import {ManagePixelsPixelRouteProps} from './_routes';

export function PixelDebug({organization, pixel}: ManagePixelsPixelRouteProps) {
  return <PixelDebugger organization={organization} pixel={pixel} />;
}
